/**
 * Models a chart project
 */

import Brace from "backbone.brace";
import User from "../account-data";
import UserCollection from "../../collections/chart-reviews/reviewers/selectable";
import KeyValueStringCollection from "../../collections/key-string-value";
import environment from "../../common/environment";
import _ from "underscore";

const Model = Brace.Model.extend({
  urlRoot: environment.getEndpoint("chart-reviews:projects"),
  namedAttributes: {
    id: Number,
    name: String,
    users: UserCollection,
    // managers and reviewers are loosely typed on purpose as they can carry
    // a UserCollection or an array of IDs depending on which screens uses
    // them.
    managers: Object,
    reviewers: Object,
    statuses: KeyValueStringCollection,
    statusValue: String,
    openedDate: Date,
    openedBy: User,
    closedDate: Date,
    closedBy: User,
    modifiable: Boolean,
    closed: Boolean,
    closable: Boolean,
    deletable: Boolean,
    auditChartProject: Boolean,
    notes: String,
  },
  defaults: {
    id: null,
    name: null,
    users: null,
    managers: [],
    reviewers: [],
    statusValue: null,
    openedDate: null,
    openedBy: null,
    closedDate: null,
    closedBy: null,
    modifiable: null,
    closed: null,
    closable: null,
    deletable: null,
    auditChartProject: null,
    notes: null,
  },
  validate(attrs) {
    // "name" cannot be empty
    if (_.isEmpty(attrs.name)) {
      return "You must enter a name for this project.";
    }
  },
});

export { Model as default };
